import React, { useState } from 'react';

const AthletesContext = React.createContext([{}, () => {}]);

const AthletesProvider = (props) => {
    const [athletesState, setAthletesState] = useState({
        theAthletes: [],
        theAthlete: {
            _id: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            dateOfBirth: "",
            gender: "",
            sport: "",
            position: "",
            teamName: "",
            jerseyNumber: "",
            height: "",
            weight: "",
            address: "",
            city: "",
            state: "",
            zipCode: "",
            emergencyContactName: "",
            emergencyContactPhone: "",
            status: "Active",
            notes: ""
        },
    });
    return (
        <AthletesContext.Provider value={[athletesState, setAthletesState]}>
            {props.children}
        </AthletesContext.Provider>
    );
};

export { AthletesContext, AthletesProvider };
